<script>import { Button } from "@infinitro/button";
import { closeThisModal, ModalDialog, stateOpenModal } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { Text } from "@infinitro/text";
import { dismissUpdate, doUpdate, updateVersion } from "../versioning";
export const thisModal = ModalDialog.Update;
async function handleDismiss() {
  await dismissUpdate();
  closeThisModal(thisModal);
}
async function handleUpdate() {
  await doUpdate();
  closeThisModal(thisModal);
}
</script>

{#if $stateOpenModal === thisModal}
	<Modal title="Update Available" closeModal={handleDismiss}>
		<Text>There is a new version of the website available. [{$updateVersion}]</Text>
		<br />
		<Button onClick={handleUpdate}>Update Now</Button>
	</Modal>
{/if}
